var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuickSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2)",
    stroke: "#ff781f",
    strokeWidth: 3,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 11.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.333 26.333L20 19"
  }))));
}

export default SvgQuickSearch;